"use strict";

exports.__esModule = true;
exports.getEstimateMintResult = getEstimateMintResult;
var _sdkCore = require("@acala-network/sdk-core");
var _errors = require("../errors");
var _exchangeRate = require("./exchange-rate");
function getEstimateMintResult(amount, env) {
  const {
    mintThreshold,
    totalStaking,
    stakingSoftCap,
    exchangeRate,
    estimatedRewardRatePerEra
  } = env;
  if (amount.lt(mintThreshold)) throw new _errors.BelowMintThreshold();
  if (totalStaking.add(amount).gt(stakingSoftCap)) throw new _errors.ExceededStakingCurrencySoftCap();
  const liquditAmount = (0, _exchangeRate.convertStakingToLiquid)(exchangeRate, amount);
  const receive = liquditAmount.div(_sdkCore.FixedPointNumber.ONE.add(estimatedRewardRatePerEra));
  return {
    pay: amount,
    receive,
    env
  };
}